import { AjaxResponse } from "rxjs/ajax";

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum RequestContentType {
  MULTIPART = 1,
  BINARY_STREAM = 2,
}

export interface HttpOptions {
  queryParams?: Record<string, ParamTypes>;
  body?: Record<string, unknown> | FormData | File;
  headers?: Record<string, unknown>;
  requestContentType?: RequestContentType;
  /** Request chạy nền (vd: hỏi lại mỗi 5s): không hiện toast lỗi, không hiện loading và luôn trả lỗi về cho nơi gọi */
  silent?: boolean;
  /**
   * Cách hiện loading: "overlay" che cả trang (thao tác của người dùng), "bar" thanh mảnh trên đầu trang
   * (tải dữ liệu, không che trang), "none" không hiện. Mặc định: GET -> "bar", còn lại -> "overlay".
   */
  loading?: LoadingMode;
}

export type LoadingMode = "overlay" | "bar" | "none";

type ParamTypes =
  | number
  | string
  | string[]
  | undefined
  | { [key: string]: any };

type JsonType = string | number | boolean | object | Array<any> | null | any;

export interface DataSet {
  [key: string]: JsonType;
}

export interface ResponsePagination {
  page: number;
  perPage: number;
  total: number;
  lastPage: number;
}

export type PaginateSearchValue = string | number | boolean | any[];

export interface PaginationOption {
  page?: number;
  perPage?: number;
  total?: number;
  equal?: { [key: string]: PaginateSearchValue };
  like?: { [key: string]: PaginateSearchValue };
  sort?: string;
  in?: { [key: string]: PaginateSearchValue[] };
}

export interface ResponseResult {
  data: DataSet | DataSet[];
  pagination?: ResponsePagination;
}

export interface CoreResponse {
  status: number;
  message: string;
  result?: ResponseResult | DataSet;
}

export interface ProgressOptions {
  includeUploadProgress: boolean;

  progressHandler: (ajaxResponse: AjaxResponse<any>) => void;
}
